import * as React from 'react';
import {
  List, ListItem, ListItemButton, ListItemIcon, ListItemText,
  Stack, Divider, Collapse, Typography
} from '@mui/material';
import {
  HomeRounded as HomeRoundedIcon,
  PeopleRounded as PeopleRoundedIcon,
  SettingsRounded as SettingsRoundedIcon,
  History as HistoryIcon,
  Language as LanguageIcon,
  MonitorHeart as MonitorHeartIcon,
  Microsoft as MicrosoftIcon,
  Storage as StorageIcon,
  Draw as DrawIcon,
  Shield as ShieldIcon,
  Key as KeyIcon,
  Person as PersonIcon,
  Computer as ComputerIcon,
  ExpandLess,
  ExpandMore,
  InsertDriveFile as InsertDriveFileIcon,
  Support as SupportIcon,
  Handshake as HandshakeIcon,
  GridOn as GridOnIcon,
  Dashboard as DashboardIcon,
  Newspaper as NewspaperIcon,
  FileUpload as FileUploadIcon,
  ArrowForwardIos as ArrowForwardIosIcon,
  CorporateFare as CorporateFareIcon,
  Inventory as InventoryIcon,
  Timeline,
  DirectionsCar
} from '@mui/icons-material';

import { NavLink, useLocation, useNavigate } from "react-router";

const mainListItems = [
  { text: 'Home', icon: <DashboardIcon />, value: 'dashboard/home' },

  { section: 'Opérations' },
  {
    text: 'Clients', icon: <CorporateFareIcon />, value: 'dashboard/organizations', subItems: [
      { text: 'Liste des clients', value: '', icon: <CorporateFareIcon /> },
      { text: 'Liste des utilisateurs', value: 'users', icon: <PeopleRoundedIcon /> },
    ]
  },
  {
    text: 'Devis', icon: <InsertDriveFileIcon />, value: 'dashboard/quotes', subItems: [
      { text: 'Liste des devis', value: '', icon: <DashboardIcon /> },
      { text: 'Signer le devis', value: 'form', icon: "" },
    ],
  },
  {
    text: 'Contrats', icon: <HandshakeIcon />, value: 'dashboard/contrats', subItems: [
      { text: 'Dashboard', value: '', icon: <DashboardIcon /> },
      { text: 'Annuel', value: 'annual', icon: <DashboardIcon /> },
      { text: 'Mensuel', value: 'monthly', icon: <DashboardIcon /> },
      { text: 'Liste des contrats', value: 'list', icon: <DashboardIcon /> },
      { text: 'Matrice de compétences', value: 'matrix', icon: <GridOnIcon /> },
    ],
  },
 
  { text: 'Ticketing', icon: <SupportIcon />, value: 'dashboard/tickets', subItems: [
      { text: 'Tickets', value: '', icon: <SupportIcon /> },
      { text: 'Temps passés', value: 'timeEntry', icon: <Timeline /> },
      { text: 'IK', value: 'ik', icon: <DirectionsCar /> },
      { text: 'Mes IK', value: 'myik', icon: <DirectionsCar /> },
    ],},
  { text: 'Historique', icon: <HistoryIcon />, value: 'dashboard/history' },

  { section: 'Infrastructure' },
  { text: 'Nom de domaine', icon: <LanguageIcon />, value: 'dashboard/domain' },
  { text: 'Centreon', icon: <MonitorHeartIcon />, value: 'dashboard/centreon' },
  {
    text: 'O365', icon: <MicrosoftIcon />, value: 'dashboard/o365', subItems: [
      { text: 'Général', value: '', icon: <DashboardIcon /> },
      { text: 'Licenses', value: 'licenses', icon: <KeyIcon /> },
      { text: 'Utilisateurs', value: 'users', icon: <PersonIcon /> },
    ],
  },
  {
    text: 'Veeam Backup O365', icon: <StorageIcon />, value: 'dashboard/vbo365', subItems: [
      { text: 'Général', value: '', icon: <DashboardIcon /> },
      { text: 'Licenses', value: 'licenses', icon: <KeyIcon /> },
      { text: 'Utilisateurs', value: 'users', icon: <PersonIcon /> },
    ],
  },
  {
    text: 'ESET', icon: <ShieldIcon />, value: 'dashboard/eset', subItems: [
      { text: 'Général', value: '', icon: <DashboardIcon /> },
      { text: 'Licenses', value: 'licenses', icon: <KeyIcon /> },
      { text: 'Appareils', value: 'devices', icon: <ComputerIcon /> },
    ],
  },
  {
    text: 'Signitic', icon: <DrawIcon />, value: 'dashboard/signitic', subItems: [
      { text: 'Général', value: '', icon: <DashboardIcon /> },
    ],
  },
  {
    text: 'Newsletter', icon: <NewspaperIcon />, value: 'dashboard/sarbacane', subItems: [
      { text: 'Listes', value: '', icon: <DashboardIcon /> },
    ],
  },
   {
    text: 'MC3 Cloud', icon: <MicrosoftIcon />, value: 'dashboard/mc3cloud', subItems: [
      { text: 'Produits', value: 'products', icon: <InventoryIcon /> },
    ],
  },
  {
    text: 'Imports', icon: <FileUploadIcon />, value: 'dashboard/import', subItems: [
      { text: `MEG vers Pipedrive`, value: '' },
    ],
  },
  { section: 'Admin' },
  { text: 'Produits', icon: <InventoryIcon />, value: 'dashboard/products' },
  { text: 'Rapports', icon: <InventoryIcon />, value: 'dashboard/reports' },
  { text: 'Factures', icon: <InventoryIcon />, value: 'dashboard/factures' },

];

const secondaryListItems = [
  {
    text: 'Imports', icon: <InventoryIcon />, value: 'dashboard/import', subItems: [
      { text: `MEG vers Pipedrive`, value: '' },
    ],
  },
];

export default function MenuContent() {
  const location = useLocation();
  const navigate = useNavigate();
  const [openMenus, setOpenMenus] = React.useState({});

  React.useEffect(() => {
    const initialOpenMenus = {};
    mainListItems.forEach(item => {
      if (item.subItems) {
        const hasActiveSubItem = item.subItems.some(subItem =>
          location.pathname === `/${item.value}/${subItem.value}`
        );
        initialOpenMenus[item.value] = hasActiveSubItem;
      }
    });
    setOpenMenus(initialOpenMenus);
  }, [location.pathname]);

  const toggleMenu = (menuKey) => {
    setOpenMenus(prev => ({
      ...Object.fromEntries(Object.keys(prev).map(key => [key, false])),
      [menuKey]: !prev[menuKey]
    }));
  };

  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
      <List dense>
        {mainListItems.map((item, index) => {
          if (item.section) {
            return (
              <Typography
                key={`section-${index}`}
                variant="subtitle2"
                sx={{ pl: 2, pt: 1, pb: 0.5, color: 'text.secondary' }}
              >
                {item.section}
              </Typography>
            );
          }

          const mainPath = `/${item.value}`;
          const hasSubItems = Array.isArray(item.subItems);
          const isMainSelected =
            location.pathname === mainPath ||
            location.pathname.startsWith(mainPath + '/');
          const isOpen = openMenus[item.value] || false;

          return (
            <div key={index}>
              <ListItem disablePadding sx={{ display: 'block' }}>
                <ListItemButton
                  onClick={() => {
                    if (hasSubItems) {
                      toggleMenu(item.value);
                    } else {
                      navigate(mainPath);
                    }
                  }}
                  selected={!hasSubItems && isMainSelected}
                >
                  <ListItemIcon sx={{ color: !hasSubItems && isMainSelected ? 'primary.main' : 'inherit' }}>
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText primary={item.text} />
                  {hasSubItems && (isOpen ? <ExpandLess /> : <ExpandMore />)}
                </ListItemButton>
              </ListItem>

              {hasSubItems && (
                <Collapse in={isOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding dense>
                    {item.subItems.map((subItem, subIndex) => {
                      const subPath = `/${item.value}/${subItem.value}`;
                      const isSubSelected = location.pathname === subPath;

                      return (
                        <NavLink
                          to={subPath}
                          key={subIndex}
                          style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                          <ListItem disablePadding>
                            <ListItemButton sx={{ pl: 4 }} selected={isSubSelected}>
                              <ListItemIcon sx={{ color: isSubSelected ? 'primary.main' : 'inherit' }}>
                                {subItem.icon}
                              </ListItemIcon>
                              <ListItemText primary={subItem.text} />
                            </ListItemButton>
                          </ListItem>
                        </NavLink>
                      );
                    })}
                  </List>
                </Collapse>
              )}
            </div>
          );
        })}
      </List>

      {/* <Divider /> */}

      {/* <List dense>
        {secondaryListItems.map((item, index) => {
          const isSelected = location.pathname === `/${item.value}`;
          return (
            <NavLink
              to={`/${item.value}`}
              key={index}
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <ListItem disablePadding sx={{ display: 'block' }}>
                <ListItemButton selected={isSelected}>
                  <ListItemIcon sx={{ color: isSelected ? 'primary.main' : 'inherit' }}>
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItemButton>
              </ListItem>
            </NavLink>
          );
        })}
      </List> */}
    </Stack>
  );
}
